export default {
    toolbarBorderColor: 'black',
    fontFamily: [
        'Noto Sans CJK TC',
        'Noto Sans TC',
        '-apple-system',
        'BlinkMacSystemFont',
        'Segoe UI',
        'Roboto',
        'Oxygen',
        'Ubuntu',
        'Cantarell',
        'Fira Sans',
        'Droid Sans',
        'Helvetica Neue',
        'sans-serif'
    ].join(',')
};

export const PALETTE = {
    primary: '#000',
    secondary: '#E9D7C6',
    tertiary: '#85715C',
    fourth: '#E1D4C5',
    black: '#000',
    white: '#fff',
    transparent: 'transparent',
    text: { primary: '#000', light: '#FFFFFF', muted: '#b1b0b0', danger: '#C23434', dark: '#BEB5AB' },
    blue: { normal: '#65C9D6' },
    green: { normal: '#90ee90' },
    gray: {
        dark: '#A19FB2',
        normal: '#79797c',
        light: '#F6F5F3',
        muted: '#EFEDE7',
        extraLight: '#F1EDE7',
        disabled: '#E1E1E1'
    },
    // purple: { dark: '#a277f8', normal: '#eee5fe' },
    yellow: { dark: '#ffb136', normal: '#f8cc8f', light: '#fff4de' },
    orange: { normal: '#FF6F31' },
    red: { dark: '#b20051', normal: '#C23434', light: '#ff9696' } //#fb4141
};
